import { Category, ICategoryArgs } from "../category/category.model";

export interface ILookupTypeArgs extends ICategoryArgs {

}

export class LookupType extends Category {

    lookupType: string;

    constructor(data?: ILookupTypeArgs) {
        super(data);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.model.ts